<div [style.border-color]="color" class="list-element-container flex-column align-center">
  <div [style.background]="color" class="circle flex align-center justify-center mt-2">
    <i class="material-icons">{{ icon }}</i>
  </div>
  <div class="text-container">
    <p>{{ text }}</p>
  </div>
</div>
